import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, CircularProgress, Typography, FormControl } from "@material-ui/core";

const styles = theme => ({
    btn: { textAlign: 'right', marginLeft: '50%', marginBottom: '0.3rem' },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh'
    },
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

const ForgotPasswordForm = (props) => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched } = formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Typography variant={"h6"}>{translations['password_change_email'] || 'Please enter email for password reset'}</Typography>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['email'] || 'Email'}
                                placeholder={translations['email'] || 'Email'}
                                name="Email"
                                fullWidth={true}
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Email && touched.Email)}
                            />
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !(isValid && dirty)}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null
                        }
                    </form>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(ForgotPasswordForm);
